import { render, staticRenderFns } from "./root.vue?vue&type=template&id=1b7a129a&scoped=true&"
import script from "./root.ts?vue&type=script&lang=ts&"
export * from "./root.ts?vue&type=script&lang=ts&"
import style0 from "./root.vue?vue&type=style&index=0&id=1b7a129a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7a129a",
  null
  
)

export default component.exports